import { Anchor, Box, Breadcrumbs, Text } from "@mantine/core";
import { IValueLabel } from "@mctypes/global.types";
import React from "react";

const ListWithArrowItems: React.FC<{ listArrowItems: IValueLabel[] }> = ({ listArrowItems }) => {
  const items = (listArrowItems || []).map((item, index) => {
    const isLast = index === listArrowItems.length - 1;
    return (
      <Box key={index} maw={300} className="text-truncate">
        {isLast ? (
          <Text fz="1em" fw={300}>
            {item.label}
          </Text>
        ) : (
          <Anchor
            fw={300}
            fz="1em"
            c="mc-primary"
            style={{ cursor: "pointer" }}
            href={`#${item.value}`}
            underline="never"
          >
            {item.label}
          </Anchor>
        )}
      </Box>
    );
  });

  return (
    <Breadcrumbs separator="/" bg={"lightgray.0"} px={"sm"} py={"xs"}>
      {items}
    </Breadcrumbs>
  );
};

export default ListWithArrowItems;
